import { useCallback } from 'react';

const useTargetingCancel = (ws, gameId, setError) => {
  const createCancelDeployHandler = useCallback((setDeployTargetMode, setSelectedDeployOrderId, setSelectedDeployInstanceId, setSelectedDeployZone, setDeployTargetInfo, selectedDeployOrderId, selectedDeployInstanceId, selectedDeployZone) => {
    return () => {
      // Unit 349 (Enhanced Scorpion) requires mandatory targeting - cannot cancel
      if (selectedDeployOrderId === 349) {
        console.warn('Cannot cancel targeting for unit 349 (Enhanced Scorpion) - targeting is mandatory');
        return;
      }
      
      if (ws && ws.readyState === 1) {
        const cancelAction = {
          type: 'cancelDeployTargeting',
          orderId: selectedDeployOrderId,
          instanceId: selectedDeployInstanceId,
          zone: selectedDeployZone
        };
        const message = { type: "play-turn", gameId, action: cancelAction };
        ws.send(JSON.stringify(message));
      }
      setDeployTargetMode(false);
      setSelectedDeployOrderId(null);
      setSelectedDeployInstanceId(null);
      setSelectedDeployZone(null);
      setDeployTargetInfo(null);
    };
  }, [ws, gameId]);

  const createCancelStrategemHandler = useCallback((setStrategemTargetMode, setSelectedStrategemId, setStrategemTargetInfo) => {
    return () => {
      if (ws && ws.readyState === 1) {
        const cancelAction = { type: 'cancelStrategemTargeting' };
        const message = { type: "play-turn", gameId, action: cancelAction };
        ws.send(JSON.stringify(message));
      }
      setStrategemTargetMode(false);
      setSelectedStrategemId(null);
      setStrategemTargetInfo(null);
    };
  }, [ws, gameId]);

  const createCancelWeaponHandler = useCallback((setWeaponTargetMode, setSelectedWeaponId, setSelectedWeaponInstanceId = null) => {
    return () => {
      setWeaponTargetMode(false);
      setSelectedWeaponId(null);
      if (setSelectedWeaponInstanceId) {
        setSelectedWeaponInstanceId(null);
      }
    };
  }, []);

  const createCancelWeaponDeployHandler = useCallback((setWeaponDeployTargetMode, setWeaponDeployTargetInfo) => {
    return () => {
      setWeaponDeployTargetMode(false);
      setWeaponDeployTargetInfo(null);
    };
  }, []);

  const createCancelDroneHandler = useCallback((setDroneTargetMode, setSelectedDroneId, setSelectedDroneInstanceId) => {
    return () => {
      setDroneTargetMode(false);
      setSelectedDroneId(null);
      setSelectedDroneInstanceId(null);
    };
  }, []);

  return {
    createCancelDeployHandler,
    createCancelStrategemHandler,
    createCancelWeaponHandler,
    createCancelWeaponDeployHandler,
    createCancelDroneHandler
  };
};

export default useTargetingCancel;
